function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#1F140F",
  d: "M23.719 15.875L10.814 28.78l1.061 1.06L25.84 15.875 11.875 1.91l-1.06 1.06z",
  fillRule: "evenodd"
});

var SvgRight = function SvgRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4NCjxzdmcgd2lkdGg9IjMycHgiIGhlaWdodD0iMzJweCIgdmlld0JveD0iMCAwIDMyIDMyIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPg0KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggNTkuMSAoODYxNDQpIC0gaHR0cHM6Ly9za2V0Y2guY29tIC0tPg0KICAgIDx0aXRsZT5pY29ub2dyYWZpYS8zMngzMi9yaWdodDwvdGl0bGU+DQogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+DQogICAgPGcgaWQ9Imljb25vZ3JhZmlhLzMyeDMyL3JpZ2h0IiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4NCiAgICAgICAgPHBvbHlnb24gaWQ9IlBhdGgiIGZpbGw9IiMxRjE0MEYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDExLjg3NTAwMCwgMTUuODc1MDAwKSByb3RhdGUoLTEzNS4wMDAwMDApIHRyYW5zbGF0ZSgtMTEuODc1MDAwLCAtMTUuODc1MDAwKSAiIHBvaW50cz0iMy41IDI0LjI1IDMuNSA2IDIgNiAyIDI1Ljc1IDIxLjc1IDI1Ljc1IDIxLjc1IDI0LjI1Ij48L3BvbHlnb24+DQogICAgPC9nPg0KPC9zdmc+";
export { SvgRight as ReactComponent };